export default "__VITE_ASSET__yd7J8zL0__"